import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#example-7" }),
  /*#__PURE__*/_createTextVNode(" Tags with custom tags slot ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "bg-dark text-white rounded-1 mb-2 p-3" }
const _hoisted_5 = { class: "multiselect-tag is-user" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, " Data: " + _toDisplayString(_ctx.example7.value), 1),
      _createVNode(_component_Multiselect, _mergeProps({
        modelValue: _ctx.example7.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.example7.value) = $event))
      }, _ctx.example7), {
        tag: _withCtx(({ option, handleTagRemove, disabled }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: option.image
            }, null, 8, _hoisted_6),
            _createTextVNode(" " + _toDisplayString(option.name) + " ", 1),
            (!disabled)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                  onMousedown: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent","stop"])
                }, null, 40, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("img", {
            class: "user-image",
            src: option.image
          }, null, 8, _hoisted_8),
          _createTextVNode(" " + _toDisplayString(option.name), 1)
        ]),
        _: 1
      }, 16, ["modelValue"]),
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.htmlCode), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.jsCode), 1)
        ]),
        _: 1
      })
    ])
  ]))
}